var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDisplaySmallCustomPayOff = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h30v30H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.43 20.123a.438.438 0 0 1 .4-.255h3.504v-7.214a12.252 12.252 0 0 0-3.08-3.599H8.271C5.01 11.5 3 16.538 3 19.868c0 4.437 3.312 4.758 8.762 4.758 2.3 0 4.35-.044 5.88-.524L14.5 20.586a.428.428 0 0 1-.07-.463zm-7.487-4.148c0-2.627 2.158-4.757 4.82-4.757 2.66 0 4.819 2.13 4.819 4.757 0 2.628-2.158 4.758-4.82 4.758-2.66-.002-4.817-2.13-4.819-4.758z",
    fill: "#9A5238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.762 12.083c-2.177 0-3.943 1.742-3.943 3.892s1.766 3.893 3.943 3.893c2.178 0 3.943-1.743 3.943-3.893-.003-2.148-1.766-3.889-3.943-3.892zm2.19 3.027h-.875v-.432a.435.435 0 0 0-.438-.433h-1.753a.435.435 0 0 0-.438.433v.432c0 .24.196.433.438.433h1.753a1.31 1.31 0 0 1 1.314 1.297v.433a1.31 1.31 0 0 1-1.314 1.297H12.2v.433h-.876v-.433h-.438a1.31 1.31 0 0 1-1.314-1.297h.876c0 .239.196.432.438.432h1.753a.435.435 0 0 0 .438-.432v-.433a.435.435 0 0 0-.438-.432h-1.753a1.31 1.31 0 0 1-1.314-1.298v-.432a1.31 1.31 0 0 1 1.314-1.298h.438v-.432h.876v.432h.439a1.31 1.31 0 0 1 1.314 1.298v.432z",
    fill: "#1E2969"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.913 6.46-.332-1.643.858-.173.368 1.816h2.774l.376-2.232.868.139-.355 2.093h.526l.609-2.634a2.982 2.982 0 0 1-1.144-.454 2.245 2.245 0 0 0-2.475 0 2.926 2.926 0 0 1-1.683.493c-.6.012-1.19-.16-1.686-.493a2.462 2.462 0 0 0-.649-.303l.916 3.391h1.03z",
    fill: "#9A5238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.03 20.733a.435.435 0 0 1-.439-.433V3h-4.38v17.3a.435.435 0 0 1-.439.433h-2.97L21.4 27 27 20.733h-2.97z",
    fill: "#F6C760"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.214 8.181 7.053.01a.435.435 0 0 0 .438-.433.435.435 0 0 0-.438-.433h-7.01a.435.435 0 0 0-.438.433.43.43 0 0 0 .395.423z",
    fill: "#9A5238"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDisplaySmallCustomPayOff);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/display-small-custom-pay-off.b9325411a50c074520c913d12ed2bee6.svg";